import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, Input, OnInit, signal, ViewChild } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { PersonalQualificationByAdvisors } from '../../dashboard-interfaces/personal-qualification-by-advisors.interface';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { SnackbarService } from '../../../../shared/services/snackbar/snackbar.service';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ClubQualificationByAdvisors } from '../../dashboard-interfaces/club-qualification-by-advisors.interface';
import { DashboardPiasConventionService } from '../../dashboard-services/dashboard-pias-convention/dashboard-pias-convention.service';
import { HttpStatusCode } from 'axios';
import { Router } from '@angular/router';
import { TabState } from '../../dashboard-interfaces/tab-state.interface';
import { QualificationStatuses } from '../../dashboard-enums/qualification-statuses.enum';

@Component({
  selector: 'dashboard-pias-convention',
  imports: [
    CommonModule,
    MatCardModule,
    MatDividerModule,
    MatIconModule,
    MatDividerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule
  ],
  templateUrl: './pias-convention.component.html',
  styleUrl: './pias-convention.component.scss'
})
export class PiasConventionComponent implements OnInit, AfterViewInit {

  private router = inject(Router);
  private sessionStorageService = inject(SessionStorageService);
  private snackBarService = inject(SnackbarService);
  private dashboardPiasConventionService = inject(DashboardPiasConventionService);

  protected readonly QualificationStatus = QualificationStatuses;

  protected currentUserRole: string = '';
  protected totalPersonalQualifiedAdvisorsCount: number = 0;

  setSprinner = signal(false);
  isQualifiedAdvisorsCountHidden = signal(false);
  isQualificationTableFilterAndPaginatorHidden = signal(false);

  private personalQualificationByAdvisorData: PersonalQualificationByAdvisors[] = [];
  protected personalQualificationByAdvisorTableDisplayColumn: string[] = [];
  protected personalQualificationByAdvisorTableDataSource = new MatTableDataSource<PersonalQualificationByAdvisors>();
  private clubQualificationByAdvisorData: ClubQualificationByAdvisors[] = [];
  protected clubQualificationByAdvisorTableDisplayColumn: string[] = [];
  protected clubQualificationByAdvisorTableDataSource = new MatTableDataSource<ClubQualificationByAdvisors>();

  personalQualificationByAdvisorTableFilterFc = new FormControl("");
  clubQualificationByAdvisorTableFilterFc = new FormControl("");

  @ViewChild('personalQualificationByAdvisorPaginator')
  personalQualificationByAdvisorPaginator!: MatPaginator;
  @ViewChild('personalQualificationByAdvisorSort')
  personalQualificationByAdvisorSort = new MatSort();
  @ViewChild('clubQualificationByAdvisorPaginator')
  clubQualificationByAdvisorPaginator!: MatPaginator;
  @ViewChild('clubQualificationByAdvisorSort')
  clubQualificationByAdvisorSort = new MatSort();

  @Input('tabState')
  set tabState(state: TabState) {
    this.isCurrentTabActive = state.isActive;
    this.targetYear = state.targetYear;

    this.setAsCurrentTab();
  }

  protected conventionPersonalQualificationDisclaimer: string = "";
  protected conventionClubQualificationDisclaimer: string = "";

  protected isCurrentTabActive: boolean = false;
  protected targetYear: string = "";

  private readonly pqQualifiedStatus: string[] = [QualificationStatuses.MET_VIP_2, QualificationStatuses.MET_VIP_1, QualificationStatuses.MET_MAIN];

  constructor() { }

  async ngOnInit(): Promise<void> {
    this.currentUserRole = this.sessionStorageService.getCurrentUserRole();

    if (['Corporate', 'BDM'].includes(this.currentUserRole)) {
      this.personalQualificationByAdvisorTableDisplayColumn = ["repCode", "personName", "branch", "lifeInsurance", "investment", "generalInsurance", "feeAndReferral", "total", "target", "shortfall", "metOrNotmet"];
      this.clubQualificationByAdvisorTableDisplayColumn = ["repCode", "personName", "branch", "grow", "ifast", "totalNetInflowNew", "target", "shortfall", "metOrNotmet"];
    }
    else {
      this.personalQualificationByAdvisorTableDisplayColumn = ["repCode", "personName", "lifeInsurance", "investment", "generalInsurance", "feeAndReferral", "total", "target", "shortfall", "metOrNotmet"];
      this.clubQualificationByAdvisorTableDisplayColumn = ["repCode", "personName", "grow", "ifast", "totalNetInflowNew", "target", "shortfall", "metOrNotmet"];
    }
  }

  ngAfterViewInit(): void {
    this.personalQualificationByAdvisorTableDataSource.paginator = this.personalQualificationByAdvisorPaginator;
    this.personalQualificationByAdvisorTableDataSource.sort = this.personalQualificationByAdvisorSort;

    this.clubQualificationByAdvisorTableDataSource.paginator = this.clubQualificationByAdvisorPaginator;
    this.clubQualificationByAdvisorTableDataSource.sort = this.clubQualificationByAdvisorSort;
  }

  async setAsCurrentTab(): Promise<void> {
    this.personalQualificationByAdvisorData = [];
    this.clubQualificationByAdvisorData = [];

    if (this.isCurrentTabActive) {
      await this.getPiasConventionData();

      // this.personalQualificationByAdvisorTableDataSource.data = this.personalQualificationByAdvisorData;
      this.__applyPersonalQualificationByAdvisorDataFilter();
      // this.clubQualificationByAdvisorTableDataSource.data = this.clubQualificationByAdvisorData;
      this.__applyClubQualificationByAdvisorDataFilter();

      if (['Advisor'].includes(this.currentUserRole)) {
        this.isQualifiedAdvisorsCountHidden.set(true);
        this.isQualificationTableFilterAndPaginatorHidden.set(true);
      }
    }
  }

  async getPiasConventionData() {
    this.setSprinner.set(true);

    const responseData = await this.dashboardPiasConventionService
      .getDashboardPiasConvention(Number.parseInt(this.targetYear))
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });

    this.setSprinner.set(false);

    if (responseData.status === HttpStatusCode.Ok) {
      // Manager, Director : apedata, apesummary
      // Agent : apesummary
      // Corporate : branchdata, corporateapedata
      // BDM : bdmapedata, bdmbranchreporting
      if (this.currentUserRole === 'Corporate') {
        this.mapPiasConventionData(responseData.data.responsedata.corporateapedata, responseData.data.responsedata.projectconfiguration);
      }
      else if (this.currentUserRole === 'BDM') {
        this.mapPiasConventionData(responseData.data.responsedata.bdmapedata, responseData.data.responsedata.projectconfiguration);
      }
      else if (['Manager', 'Director'].includes(this.currentUserRole)) {
        this.mapPiasConventionData(responseData.data.responsedata.apedata, responseData.data.responsedata.projectconfiguration);
      }
      else {
        this.mapPiasConventionData(responseData.data.responsedata.apedata, responseData.data.responsedata.projectconfiguration);
      }

      this.setDisclaimers(responseData.data.responsedata.disclamirdata);
    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

  private setDisclaimers(disclaimer: any[]) {
    if (this.targetYear == new Date().getFullYear().toString()) {
      this.conventionPersonalQualificationDisclaimer = disclaimer.filter(dmItem => dmItem.dmType === "convention_personal_qualification")[0].dmText.toString();
      this.conventionClubQualificationDisclaimer = disclaimer.filter(dmItem => dmItem.dmType === "convention_club_qualification")[0].dmText.toString();
    } else {
      this.conventionPersonalQualificationDisclaimer = "The Information is based on data as at 31/12/2025.";
      this.conventionClubQualificationDisclaimer = "The Information is based on data as at 31/12/2025.";
    }
  }

  protected mapPiasConventionData(pcDataList: any[], projConfig: any[]) {
    let pqMetVip2: PersonalQualificationByAdvisors[] = [];
    let pqMetVip1: PersonalQualificationByAdvisors[] = [];
    let pqMetMain: PersonalQualificationByAdvisors[] = [];
    let pqMetInvt: PersonalQualificationByAdvisors[] = [];
    let pqNotMet: PersonalQualificationByAdvisors[] = [];

    let cqMetVip1: ClubQualificationByAdvisors[] = [];
    let cqMetMain: ClubQualificationByAdvisors[] = [];
    let cqMetGr: ClubQualificationByAdvisors[] = [];
    let cqMetNq: ClubQualificationByAdvisors[] = [];
    let cqNotMet: ClubQualificationByAdvisors[] = [];

    const conventionPersonalMain: number = Number.parseInt(projConfig.filter(pcItem => pcItem.pjConfName === "Convention_Personal_Main")[0].pjConfValue);
    const conventionPersonalVip1: number = Number.parseInt(projConfig.filter(pcItem => pcItem.pjConfName === "Convention_Personal_VIP_1")[0].pjConfValue);
    const conventionPersonalVip2: number = Number.parseInt(projConfig.filter(pcItem => pcItem.pjConfName === "Convention_Personal_VIP_2")[0].pjConfValue);

    const conventionClub: number = Number.parseInt(projConfig.filter(pcItem => pcItem.pjConfName === "Convention_Club")[0].pjConfValue);

    this.totalPersonalQualifiedAdvisorsCount = 0

    pcDataList.forEach((pcDataItem) => {
      let pqData: PersonalQualificationByAdvisors = {
        repCode: pcDataItem.piasRepCode.toString(),
        personName: pcDataItem.agentRealName.toString(),
        branch: pcDataItem.branch.toString(),
        lifeInsurance: pcDataItem.conventionPerQualLifeInsurance.toString(),
        investment: pcDataItem.conventionPerQualInvestment.toString(),
        generalInsurance: pcDataItem.conventionPerQualGi.toString(),
        feeAndReferral: pcDataItem.conventionPerQualFeeAndReferral.toString(),
        total: pcDataItem.conventionPerQualTot.toString(),
        target: conventionPersonalMain.toString(),
        shortfall: "0",
        userGroup: pcDataItem.userGroup.toString(),
        qualificationStatus: (pcDataItem.convPerQuaStatus.toString()) ? pcDataItem.convPerQuaStatus.toString() : QualificationStatuses.NOT_MET
      };

      let pqShortfall: number = 0;

      if (pcDataItem.conventionPerQualTot < conventionPersonalMain) {
        pqShortfall = pcDataItem.conventionPerQualTarget - pcDataItem.conventionPerQualTot;
      } else {
        pqShortfall = 0;
      }

      if (this.pqQualifiedStatus.includes(pqData.qualificationStatus)) {
        this.totalPersonalQualifiedAdvisorsCount = this.totalPersonalQualifiedAdvisorsCount + 1;
      }

      pqData.shortfall = pqShortfall.toString();

      // this.personalQualificationByAdvisorData.push(pqData);
      if (pqData.qualificationStatus == this.QualificationStatus.MET_VIP_2) {
        pqMetVip2.push(pqData);
      }
      if (pqData.qualificationStatus == this.QualificationStatus.MET_VIP_1) {
        pqMetVip1.push(pqData);
      }
      if (pqData.qualificationStatus == this.QualificationStatus.MET_MAIN) {
        pqMetMain.push(pqData);
      }
      if (pqData.qualificationStatus == this.QualificationStatus.MET_INVT) {
        pqMetInvt.push(pqData);
      }
      if (pqData.qualificationStatus == this.QualificationStatus.NOT_MET) {
        pqNotMet.push(pqData);
      }

      let cqData: ClubQualificationByAdvisors = {
        repCode: pcDataItem.piasRepCode.toString(),
        personName: pcDataItem.agentRealName.toString(),
        branch: pcDataItem.branch.toString(),
        grow: pcDataItem.conventionInvestClubQualGrow.toString(),
        ifast: pcDataItem.conventionInvestClubQualIfast.toString(),
        totalNetInflowNew: pcDataItem.conventionInvestClubQualTotNetInflow.toString(),
        target: conventionClub.toString(),
        shortfall: "0",
        userGroup: pcDataItem.userGroup.toString(),
        qualificationStatus: (pcDataItem.convInvQuaStatus.toString()) ? pcDataItem.convInvQuaStatus.toString() : QualificationStatuses.NOT_MET
      };

      let cqShortfall: number = 0;

      if (pcDataItem.conventionInvestClubQualTotNetInflow < pcDataItem.conventionInvestClubQualTarget) {
        cqShortfall = pcDataItem.conventionInvestClubQualTarget - pcDataItem.conventionInvestClubQualTotNetInflow;
      } else {
        cqShortfall = 0;
      }

      cqData.shortfall = cqShortfall.toString();

      // this.clubQualificationByAdvisorData.push(cqData);

      if (cqData.qualificationStatus == this.QualificationStatus.MET_VIP_1) {
        cqMetVip1.push(cqData);
      }
      if (cqData.qualificationStatus == this.QualificationStatus.MET_MAIN) {
        cqMetMain.push(cqData);
      }
      if (cqData.qualificationStatus == this.QualificationStatus.MET_NQ) {
        cqMetNq.push(cqData);
      }
      if (cqData.qualificationStatus == this.QualificationStatus.MET_GR) {
        cqMetGr.push(cqData);
      }
      if (cqData.qualificationStatus == this.QualificationStatus.NOT_MET) {
        cqNotMet.push(cqData);
      }

    });

    // Sorting and Merging the all Personal qualification into one.
    pqMetVip2
      .sort((item1, item2) => Number.parseInt(item2.total) - Number.parseInt(item1.total))
      .forEach((item) => {
        this.personalQualificationByAdvisorData.push(item);
      });

    pqMetVip1
      .sort((item1, item2) => Number.parseInt(item2.total) - Number.parseInt(item1.total))
      .forEach((item) => {
        this.personalQualificationByAdvisorData.push(item);
      });

    pqMetMain
      .sort((item1, item2) => Number.parseInt(item2.total) - Number.parseInt(item1.total))
      .forEach((item) => {
        this.personalQualificationByAdvisorData.push(item);
      });

    pqMetInvt
      .sort((item1, item2) => Number.parseInt(item2.total) - Number.parseInt(item1.total))
      .forEach((item) => {
        this.personalQualificationByAdvisorData.push(item);
      });

    pqNotMet
      .sort((item1, item2) => Number.parseInt(item2.total) - Number.parseInt(item1.total))
      .forEach((item) => {
        this.personalQualificationByAdvisorData.push(item);
      });

    // Sorting and Merging the all Club qualification into one.
    cqMetVip1
      .sort((item1, item2) => Number.parseInt(item2.totalNetInflowNew) - Number.parseInt(item1.totalNetInflowNew))
      .forEach((item) => {
        this.clubQualificationByAdvisorData.push(item);
      });

    cqMetMain
      .sort((item1, item2) => Number.parseInt(item2.totalNetInflowNew) - Number.parseInt(item1.totalNetInflowNew))
      .forEach((item) => {
        this.clubQualificationByAdvisorData.push(item);
      });

    cqMetNq
      .sort((item1, item2) => Number.parseInt(item2.totalNetInflowNew) - Number.parseInt(item1.totalNetInflowNew))
      .forEach((item) => {
        this.clubQualificationByAdvisorData.push(item);
      });

    cqMetGr
      .sort((item1, item2) => Number.parseInt(item2.totalNetInflowNew) - Number.parseInt(item1.totalNetInflowNew))
      .forEach((item) => {
        this.clubQualificationByAdvisorData.push(item);
      });

    cqNotMet
      .sort((item1, item2) => Number.parseInt(item2.totalNetInflowNew) - Number.parseInt(item1.totalNetInflowNew))
      .forEach((item) => {
        this.clubQualificationByAdvisorData.push(item);
      });

    this.personalQualificationByAdvisorData = this.personalQualificationByAdvisorData.filter(advisor => advisor.userGroup !== 'Affinity');
    this.clubQualificationByAdvisorData = this.clubQualificationByAdvisorData.filter(advisor => advisor.userGroup !== 'Affinity');

    // this.personalQualificationByAdvisorData.sort((item1, item2) => Number.parseInt(item2.total) - Number.parseInt(item1.total));
    // this.clubQualificationByAdvisorData.sort((item1, item2) => Number.parseInt(item2.totalNetInflowNew) - Number.parseInt(item1.totalNetInflowNew));
  }

  protected __applyPersonalQualificationByAdvisorDataFilter() {
    let filterValue: string = this.personalQualificationByAdvisorTableFilterFc.value?.toString() || '';

    let tempPersonalQualificationByAdvisorTableData: PersonalQualificationByAdvisors[] = [];

    if (filterValue) {
      if (['Corporate', 'BDM'].includes(this.currentUserRole)) {
        tempPersonalQualificationByAdvisorTableData = this.personalQualificationByAdvisorData.filter(pqData =>
          pqData.repCode.toLowerCase().includes(filterValue.toLowerCase())
          || pqData.personName.toLowerCase().includes(filterValue.toLowerCase())
          || pqData.branch.toLowerCase().includes(filterValue.toLowerCase())
        );

      } else {
        tempPersonalQualificationByAdvisorTableData = this.personalQualificationByAdvisorData.filter(pqData =>
          pqData.repCode.toLowerCase().includes(filterValue.toLowerCase())
          || pqData.personName.toLowerCase().includes(filterValue.toLowerCase()
          ));
      }
    } else {
      tempPersonalQualificationByAdvisorTableData = this.personalQualificationByAdvisorData;
    }

    this.personalQualificationByAdvisorTableDataSource.data = tempPersonalQualificationByAdvisorTableData;
  }

  protected __applyClubQualificationByAdvisorDataFilter() {
    let filterValue: string = this.clubQualificationByAdvisorTableFilterFc.value?.toString() || '';

    let tempClubQualificationByAdvisorTableData: ClubQualificationByAdvisors[] = [];

    if (filterValue) {
      if (['Corporate', 'BDM'].includes(this.currentUserRole)) {
        tempClubQualificationByAdvisorTableData = this.clubQualificationByAdvisorData.filter(cqData =>
          cqData.repCode.toLowerCase().includes(filterValue.toLowerCase())
          || cqData.personName.toLowerCase().includes(filterValue.toLowerCase())
          || cqData.branch.toLowerCase().includes(filterValue.toLowerCase())
        );
      } else {
        tempClubQualificationByAdvisorTableData = this.clubQualificationByAdvisorData.filter(cqData =>
          cqData.repCode.toLowerCase().includes(filterValue.toLowerCase())
          || cqData.personName.toLowerCase().includes(filterValue.toLowerCase())
        );
      }
    } else {
      tempClubQualificationByAdvisorTableData = this.clubQualificationByAdvisorData;
    }

    this.clubQualificationByAdvisorTableDataSource.data = tempClubQualificationByAdvisorTableData;
  }
  clearClubSearch() {
    this.clubQualificationByAdvisorTableFilterFc.setValue('');   // clear input
    this.__applyClubQualificationByAdvisorDataFilter();          // reapply filter
  }
  clearSearch() {
    this.personalQualificationByAdvisorTableFilterFc.setValue('');   // clear input
    this.__applyPersonalQualificationByAdvisorDataFilter();          // reapply filter
  }

}
